import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, styled, Container } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';


// Mock data for agents - replace with actual data fetch from an API or database
const agents = [
  {
    name: 'John Doe',
    title: 'Senior Loan Officer',
    imageUrl: "/assets/images/avatars/avatar_1.jpg",
  },
  {
    name: 'Taylor Morris',
    title: 'Senior Loan Officer',
    imageUrl: "/assets/images/avatars/avatar_4.jpg",
  },
  {
    name: 'Jane Smith',
    title: 'Team Lead',
    imageUrl: "/assets/images/avatars/avatar_2.jpg",
  },
  {
    name: 'Doug Wayne',
    title: 'Loan Officer',
    imageUrl: "/assets/images/avatars/avatar_3.jpg",
  },
  // Add more agents as needed
];

const AgentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(13),
}));

const Banner = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    padding: theme.spacing(1),
    paddingTop: theme.spacing(6),
    width: '100%',
    textAlign: 'center',
  }));
const AgentButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '200px', // Adjust as needed
}));

const AgentImage = styled('img')({
  width: '100%', // Adjust as needed
  height: 'auto',
  marginBottom: '8px', // Space between image and text
});

function Florida() {
    const navigate = useNavigate();
    const handleAgentClick = (agentName) => {
        // Navigate to the agent's page
        navigate(`/branchlocations/Florida/${agentName}`);
      };
  return (
    <>
    <LandingPageNav />
    <Container maxWidth="lg" sx={{ mt: 18, pt: 4, border: '1px solid #e0e0e0', borderRadius: '4px' }}>
<Banner >
      <Typography variant="h4" component="div" style={{ fontWeight: 'bold', fontSize: '2rem', padding: '20px 0' }}>
        Available Agents in Florida
      </Typography>
      </Banner>
      <AgentContainer>
          {agents.map((agent, index) => (
            <AgentButton key={index} onClick={() => handleAgentClick(agent.name.replace(/\s+/g, ''))}>
              <AgentImage src={agent.imageUrl} alt={agent.name} />
              <Typography variant="h6">{agent.name}</Typography>
              <Typography variant="subtitle1">{agent.title}</Typography>
            </AgentButton>
          ))}
        </AgentContainer>
    </Container>
    </>
  );
}

export default Florida;
